import { QueryFilter } from "./queryFilter";
export class QueryParameter {
  // filtres de la requête
  queryFilters: Array<QueryFilter> = new Array<QueryFilter>();
  // Pagination start
  start: number;
  // Pagination count
  requestedItemCount: number;
  MatTableFilter: string;
  MatTableProperties: string;
  propertyName: string;
  tableName: string;
  lineId: number;
  /** Tableau des noms des propriétés à select (SQL) envoyé à l'api pour optimisation */
  querySelect?: string[];
  // obsolete
  lignes: boolean;
  // obsolete
  combos: boolean;
}
